export default __webpack_public_path__ + "static/media/forestly-expl-05_EN.0bd2596f.png";